export enum scopeType {
  CENTRAL = 'Central',
  MUNICIPALITY = 'Municipality',
  INSTITUTION = 'Institution',
  GROUP = 'Group',
}
